var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { teal } from '@material-ui/core/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
/**
 * Create component class
 */
var LoadMoreProgressComponent = /** @class */ (function (_super) {
    __extends(LoadMoreProgressComponent, _super);
    function LoadMoreProgressComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    LoadMoreProgressComponent.prototype.render = function () {
        return (React.createElement("div", { key: 'load-more-progress', className: 'g-load-more' },
            React.createElement(CircularProgress, { size: 30, thickness: 5, style: { color: teal['A400'] } })));
    };
    return LoadMoreProgressComponent;
}(Component));
export default LoadMoreProgressComponent;



//////////////////
// WEBPACK FOOTER
// ./src/layouts/loadMoreProgress/LoadMoreProgressComponent.tsx
// module id = 1102
// module chunks = 0 1 2 3 4 5 6 7 10